/* ==========================================================================

  Globalisation

  Author:     Stephen Zsolnai (http://www.zolla.co.uk)
  Decription: Initialises everything for currency conversion, number formatting and dates.

              Based on locale.

              Uses jQuery Globalise library (https://github.com/jquery/globalize)

              The files for each locale are hand picked from jQuery Globalise and added to globalisation folder.
              To get new files for other languages, git clone (https://github.com/jquery/globalize)
              run npm install, bower install and grunt. This will generate an export with all the files to pick from.

              We don't need them all and the build task to copy 12000+ json files takes to long.
              Any new language should be manually added.

========================================================================== */
'use strict';
/*global Arrow */

const mediator = require('mediatorjs');
const uikit = require('../uikit');
const config = require('../js/config');

// Init called in index.js:start()
export function init() {
  const hasValidGlobalisationData = Arrow.globalisationItems && Arrow.translations;
  if (hasValidGlobalisationData) {
    uikit.globalisation.loadCldrData(Arrow.globalisationItems);
    uikit.globalisation.initLocale(config.locale.code);
    uikit.globalisation.loadTranslationsForLocale(
      config.locale.code,
      Arrow.translations
    );
  }
  setTimeout(function() {
    //drop in stack as there appears to be some async happenings in one of the above assignments.
    mediator.trigger(config.events.global.globalisationLoaded);
  }, 1);
}

export function pluraliseAndTranslate(domain, key, item) {
  return uikit.globalisation.pluraliseAndTranslate(domain, key, item);
}

export function formatNumber(value) {
  return uikit.globalisation.formatNumber(value);
}

export function formatCurrency(value, minimumFractionDigits, maximumFractionDigits) {
  return uikit.globalisation.formatCurrency(value, minimumFractionDigits, maximumFractionDigits);
}

export function formatCurrencyWithIso(value, isoCode, minimumFractionDigits, maximumFractionDigits) {
  return uikit.globalisation.formatCurrencyWithIso(value, isoCode, minimumFractionDigits, maximumFractionDigits)
}

export function parseNumber(value) {
  return uikit.globalisation.parseNumber(value);
}

export function stripZeros(value) {
  return uikit.globalisation.stripZeros(value);
}




// WEBPACK FOOTER //
// ./assets/utilities/globalisation.js